// extracted by mini-css-extract-plugin
export var checkbox = "_76-0";
export var circle = "_76-3";
export var horizontalContainer = "_76-7";
export var sm = "_76-5";
export var switch0 = "_76-2";
export var switchDisabled = "_76-8";
export var switchEnabled = "_76-1";
export var textSwitchContainer = "_76-9";
export var textSwitchOption = "_76-a";
export var textSwitchOptionSelected = "_76-b";
export var verticalContainer = "_76-6";
export var xs = "_76-4";